export default "/kiban/_next/static/images/top_black-2ed74e8608e138fe8b215f8b7e91fb8f.png";